angular.module('unica_material.material_controllers')

.controller('MaterialEditController', function(
	$rootScope, $scope, $state, $stateParams,
	MaterialEditService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventStages( $stateParams.event_id );


	$rootScope.getMaterial( $stateParams.id );

	$scope.pageTitle = 'Modifica Materiale';

	$rootScope.materialData = {
		event_id: $stateParams.event_id,
		orig_filename: ''
	};

	$scope.saveMaterial = function() {
		$scope.showLoader();

		var materialData = angular.copy($rootScope.materialData);

		MaterialEditService
			.update(materialData)
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Materiale aggiornato con successo!', '');
					$state.go('app.material.list', { event_id: $stateParams.event_id });
				} else {
					$rootScope.manageError(data);
				}
			});
	};

})

;